"use client";

import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "ui/components/pagination";

export default function CommonPagination(props) {
  return (
    <Pagination className={props.className}>
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            onClick={props.hasPrev ? props.prev : undefined}
            disabled={!props.hasPrev || props.disable}
            className="cursor-pointer"
          />
        </PaginationItem>

        {props.pagesToDisplay.map((item, index) => {
          const isActive = item === props.page;

          return (
            <PaginationItem key={index} className="cursor-pointer">
              <PaginationLink
                onClick={() => props.setPage(item)}
                isActive={isActive}
                disabled={props.disable}
              >
                {item}
              </PaginationLink>
            </PaginationItem>
          );
        })}

        <PaginationItem>
          <PaginationNext
            onClick={props.hasNext ? props.next : undefined}
            disabled={!props.hasNext || props.disable}
            className="cursor-pointer"
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
}
